var map = {
	"./_social-ft.svg": "0e96",
	"./angle-down.svg": "63a0",
	"./angle-left.svg": "3ece",
	"./angle-right.svg": "50b6",
	"./angle-solid-down.svg": "4b07",
	"./angle-up.svg": "a75a",
	"./askme-exclamation-bubble.svg": "68f7",
	"./askme-question-bubble.svg": "41b9",
	"./badge-award-gold.svg": "01b9",
	"./badge-award-silver.svg": "9a36",
	"./badge-verified.svg": "a757",
	"./bars.svg": "596a",
	"./calendar.svg": "32b4",
	"./camera.svg": "69e2",
	"./card-success.svg": "1ee8",
	"./case.svg": "b909",
	"./check-circle.svg": "c271",
	"./check.svg": "29a1",
	"./coins.svg": "04ac",
	"./copy.svg": "ab3d",
	"./cross.svg": "04f81",
	"./curve-arrow-2.svg": "1221",
	"./curve-arrow.svg": "0de2",
	"./dots.svg": "1f6d",
	"./email.svg": "039b",
	"./exclamation-circle.svg": "8286",
	"./exclamation-triangle.svg": "ac2c",
	"./fantalks/answered.svg": "837c",
	"./fantalks/home.svg": "db36",
	"./fantalks/inbox.svg": "cf55",
	"./fantalks/logout.svg": "c1d3",
	"./fantalks/message.svg": "faa9",
	"./fantalks/settings.svg": "d8e5",
	"./fantalks/wallet.svg": "df1f",
	"./gift.svg": "4e09",
	"./globe.svg": "662f",
	"./heart-stroke.svg": "5882",
	"./heart.svg": "2d33",
	"./info-circle.svg": "31b5",
	"./info.svg": "1c6f",
	"./link.svg": "27db",
	"./lock.svg": "ae5e",
	"./message-bubble.svg": "0f3a",
	"./microphone.svg": "dbb9",
	"./money-bag.svg": "6c31",
	"./new/angle-down.svg": "3f4c",
	"./new/world.svg": "e83f",
	"./no-avatar.svg": "8075",
	"./no-microphone.svg": "4cd5",
	"./pause.svg": "d77c",
	"./payment-apple-pay.svg": "7efd",
	"./payment-boleto-flash.svg": "8c3e",
	"./payment-br-bank.svg": "b55f",
	"./payment-br-card.svg": "8ee6",
	"./payment-cards.svg": "1bd7",
	"./payment-cryptocurrencies.svg": "2f14",
	"./payment-faster-payments-system.svg": "743a",
	"./payment-google-pay.svg": "63d4",
	"./payment-klarna.svg": "19c7",
	"./payment-mastercard.svg": "7630",
	"./payment-paypal.svg": "aa29",
	"./payment-paysafe.svg": "0f72",
	"./payment-pix.svg": "2598",
	"./payment-qiwi.svg": "3ab7",
	"./payment-sberbank.svg": "125c",
	"./payment-sberpay.svg": "71f7",
	"./payment-sms.svg": "b366",
	"./payment-trustly.svg": "bd03",
	"./payment-visa.svg": "f22c",
	"./payment-vkpay.svg": "97f7",
	"./payment-webmoney.svg": "90e8",
	"./payment-y-money.svg": "5380",
	"./pencil.svg": "a3d0",
	"./phone.svg": "f3ba",
	"./play.svg": "910c",
	"./plus.svg": "5b7b",
	"./poll.svg": "507c",
	"./question-bubble.svg": "28ed",
	"./question-circle.svg": "e46c",
	"./social-boosty.svg": "b6d3",
	"./social-dailymotion.svg": "a9cb",
	"./social-discord.svg": "9956",
	"./social-donationalerts.svg": "cda7",
	"./social-facebook.svg": "9a8d",
	"./social-fb.svg": "6b52",
	"./social-ft.svg": "0853",
	"./social-goodgame.svg": "1c10",
	"./social-mixer.svg": "3183",
	"./social-ok.svg": "0bc4",
	"./social-periscope.svg": "e319",
	"./social-smashcast.svg": "1ef7",
	"./social-telegram-colored.svg": "5711",
	"./social-telegram.svg": "8896",
	"./social-tiktok.svg": "4b0d",
	"./social-trovo.svg": "94a1",
	"./social-twitch.svg": "62c2",
	"./social-vk-user.svg": "cb54",
	"./social-vk.svg": "5a51",
	"./social-wasd.svg": "0070",
	"./social-youtube-official.svg": "0d6e",
	"./social-youtube.svg": "28b9",
	"./speaker.svg": "1093",
	"./speech-synthesis.svg": "3b0d",
	"./spinner.svg": "35fe",
	"./sticker.svg": "9caa",
	"./stop.svg": "b104",
	"./success.svg": "1c59",
	"./trash.svg": "ae65",
	"./user.svg": "f171",
	"./users.svg": "0626",
	"./verified.svg": "fea2",
	"./wallet.svg": "1181"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "efbc";